export default __webpack_public_path__ + "static/media/SENAIT_NL_EPILOG1.55936a19.mp3";